export default "__VITE_ASSET__GGH74hU2__"